// extracted by mini-css-extract-plugin
module.exports = {"basicInfoNode":"CompanySettingsTabs_basicInfoNode__NRkEI"};